<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-header">
        <img :src="logo" alt="logo" class="login-logo" />
        <h2 class="login-title">小程童信奥</h2>
        <p class="login-subtitle">登录后即可参加在线考试</p>
      </div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <el-form-item prop="mobile">
          <el-input v-model="loginForm.mobile" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"
                    maxlength="11" clearable></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <div class="code-row">
            <el-input v-model="loginForm.code" placeholder="请输入验证码" prefix-icon="el-icon-key"
                      maxlength="6" clearable></el-input>
            <el-button type="primary" plain class="code-btn" :disabled="countdown > 0"
                       @click="handleSendYzm">{{ codeBtnText }}</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit-btn" :loading="submitting" @click="handleLogin">
            登 录 / 注 册
          </el-button>
        </el-form-item>
      </el-form>
      <p class="login-tip">未注册的手机号将自动创建账号</p>
    </div>

    <!-- 滑块验证：拖动通过后才会真正发送短信 -->
    <!-- 不使用 append-to-body，让弹层留在组件内以便 scoped 样式生效 -->
    <el-dialog title="安全验证" :visible.sync="sliderVisible" width="380px"
               :close-on-click-modal="false" custom-class="slider-dialog"
               @closed="resetSlider">
      <div class="slider-panel" v-loading="sliderLoading">
        <div class="slider-stage">
          <img v-if="sliderBg" ref="sliderBg" class="slider-bg" :src="sliderBg" alt="验证码背景"
               @load="measureSlider" />
          <img v-if="sliderPuzzle" class="slider-puzzle" :src="sliderPuzzle" alt="拼图块"
               :style="puzzleStyle" />
        </div>
        <div class="slider-track" ref="sliderTrack">
          <div class="slider-track-fill" :style="{ width: sliderOffset + 'px' }"></div>
          <div class="slider-handle" :class="{ 'is-dragging': dragging }"
               :style="{ left: sliderOffset + 'px' }"
               @mousedown.prevent="onSliderDown" @touchstart.prevent="onSliderDown">
            <i class="el-icon-d-arrow-right"></i>
          </div>
          <span class="slider-track-tip" v-show="sliderOffset < 8">拖动滑块完成拼图</span>
        </div>
        <p class="slider-hint">将拼图块拖到缺口位置，松开即校验</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/common/api';
import storage from '@/common/storage.js';
export default {
  name: 'PortalLogin',
  data() {
    return {
      logo: require('@/assets/logo.png'),
      loginForm: {
        mobile: '',
        code: ''
      },
      loginRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      submitting: false,
      countdown: 0,
      timer: null,
      // ---------- 滑块验证 ----------
      sliderVisible: false,
      sliderLoading: false,
      sliderUuid: '',
      sliderBg: '',
      sliderPuzzle: '',
      sliderPuzzleY: 0,
      sliderPuzzleSize: 48,
      // 原图宽度，用于把显示像素换算回原图像素
      sliderNaturalWidth: 320,
      // 实际渲染出来的宽度，量不到时用默认值兜底
      sliderDisplayWidth: 300,
      sliderOffset: 0,
      sliderTicket: '',
      sliderVerifying: false,
      dragging: false,
      dragStartX: 0,
      dragStartOffset: 0
    }
  },
  computed: {
    codeBtnText() {
      return this.countdown > 0 ? this.countdown + '秒后重试' : '获取验证码';
    },
    // 显示尺寸与原图尺寸的比值，拖动距离需要按此换算后再提交
    sliderScale() {
      if (!this.sliderDisplayWidth || !this.sliderNaturalWidth) {
        return 1;
      }
      return this.sliderDisplayWidth / this.sliderNaturalWidth;
    },
    // 滑块手柄能移动的最大距离（滑轨宽度减去手柄宽度）
    sliderMaxOffset() {
      return Math.max(0, this.sliderDisplayWidth - 44);
    },
    puzzleStyle() {
      return {
        left: this.sliderOffset + 'px',
        top: this.sliderPuzzleY * this.sliderScale + 'px',
        width: this.sliderPuzzleSize * this.sliderScale + 'px',
        height: 'auto'
      };
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.unbindDragEvents();
  },
  methods: {
    // 发送验证码：先做手机号校验，再弹滑块，滑块过了才真正发短信
    handleSendYzm() {
      if (!/^1[3-9]\d{9}$/.test(this.loginForm.mobile)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      if (this.countdown > 0) {
        return;
      }
      this.openSlider();
    },
    // ---------- 滑块验证 ----------
    openSlider() {
      this.sliderVisible = true;
      this.resetSlider();
      this.loadSlider();
      // 弹层渲染完成后再量宽度，否则量到 0
      this.$nextTick(() => {
        this.measureSlider();
      });
    },
    // 滑轨宽度与实际渲染宽度一致（都是容器的 100%），用它换算偏移量最稳
    measureSlider() {
      const track = this.$refs.sliderTrack;
      if (track && track.clientWidth) {
        this.sliderDisplayWidth = track.clientWidth;
      }
    },
    loadSlider() {
      this.sliderLoading = true;
      this.sliderOffset = 0;
      api.captcha_slider().then((r) => {
        if (r.data.code === "200" && r.data.data) {
          const d = r.data.data;
          this.sliderUuid = d.uuid;
          this.sliderBg = 'data:image/png;base64,' + d.bgImg;
          this.sliderPuzzle = 'data:image/png;base64,' + d.puzzleImg;
          this.sliderPuzzleY = d.puzzleY || 0;
          this.sliderNaturalWidth = d.width || 320;
          this.sliderPuzzleSize = d.puzzleSize || 48;
          this.$nextTick(() => {
            this.measureSlider();
          });
        } else {
          this.$message.error(r.data.msg || '验证码加载失败');
        }
      }).finally(() => {
        this.sliderLoading = false;
      });
    },
    resetSlider() {
      this.sliderOffset = 0;
      this.dragging = false;
      this.unbindDragEvents();
    },
    onSliderDown(e) {
      if (this.sliderVerifying || this.sliderLoading) {
        return;
      }
      this.dragging = true;
      this.dragStartX = e.touches ? e.touches[0].clientX : e.clientX;
      this.dragStartOffset = this.sliderOffset;
      // 监听挂在 document 上，避免鼠标移出滑块后拖动中断
      document.addEventListener('mousemove', this.onSliderMove);
      document.addEventListener('mouseup', this.onSliderUp);
      document.addEventListener('touchmove', this.onSliderMove, { passive: false });
      document.addEventListener('touchend', this.onSliderUp);
    },
    onSliderMove(e) {
      if (!this.dragging) {
        return;
      }
      // touchmove 默认会滚动页面，拖动期间需要阻止
      if (e.cancelable) {
        e.preventDefault();
      }
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let offset = this.dragStartOffset + (clientX - this.dragStartX);
      offset = Math.max(0, Math.min(this.sliderMaxOffset, offset));
      this.sliderOffset = offset;
    },
    onSliderUp() {
      if (!this.dragging) {
        return;
      }
      this.dragging = false;
      this.unbindDragEvents();
      // 没拖动就松开，不提交
      if (this.sliderOffset <= 0) {
        return;
      }
      this.submitSlider();
    },
    unbindDragEvents() {
      document.removeEventListener('mousemove', this.onSliderMove);
      document.removeEventListener('mouseup', this.onSliderUp);
      document.removeEventListener('touchmove', this.onSliderMove);
      document.removeEventListener('touchend', this.onSliderUp);
    },
    submitSlider() {
      // 显示像素换算回原图像素，容差由服务端统一控制
      const offsetX = Math.round(this.sliderOffset / this.sliderScale);
      this.sliderVerifying = true;
      api.captcha_slider_check({ uuid: this.sliderUuid, offsetX }).then((r) => {
        if (r.data.code === "200" && r.data.data && r.data.data.captchaTicket) {
          this.sliderTicket = r.data.data.captchaTicket;
          this.sliderVisible = false;
          this.doSendYzm();
        } else {
          this.$message.error(r.data.msg || '验证失败，请重试');
          // 校验失败：换一张新图，避免对着同一缺口反复试探
          this.loadSlider();
        }
      }).finally(() => {
        this.sliderVerifying = false;
      });
    },
    // 真正发送短信，携带滑块验证通过拿到的一次性票据
    doSendYzm() {
      const ticket = this.sliderTicket;
      // 票据是一次性的，用完即清，避免被重复提交
      this.sliderTicket = '';
      api.send_yzm({ mobile: this.loginForm.mobile, captchaTicket: ticket }).then((r) => {
        if (r.data.code === "200") {
          this.$message.success('验证码已发送');
          this.startCountdown();
        } else {
          this.$message.error(r.data.msg || '验证码发送失败');
        }
      });
    },
    startCountdown() {
      this.countdown = 60;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        api.mobile_login({
          mobile: this.loginForm.mobile,
          code: this.loginForm.code
        }).then((r) => {
          if (r.data.code === "200") {
            this.$message.success('登录成功');
            // 清除"未登录"标记，避免 PortalLayout 因旧标记跳过会员信息拉取
            storage.removeString('portalNoLogin');
            // 登录成功后拉取会员信息缓存
            api.current_member().then((res) => {
              if (res.data.code === "200" && res.data.data) {
                storage.setString('portalMember', JSON.stringify(res.data.data));
              }
              this.goRedirect();
            }).catch(() => {
              this.goRedirect();
            });
          } else {
            this.$message.error(r.data.msg || '登录失败');
          }
        }).finally(() => {
          this.submitting = false;
        });
      });
    },
    goRedirect() {
      let redirect = this.$route.query.redirect;
      if (redirect) {
        if (this.$route.path === redirect) return;
        this.$router.push(redirect).catch(() => {});
      } else {
        if (this.$route.path === '/portal/home') return;
        this.$router.push('/portal/home').catch(() => {});
      }
    }
  }
};
</script>
<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  background: linear-gradient(125deg, #1E6AD8 0%, #2B7EF5 50%, #4A91F7 100%);
}
/* 左上暖色光晕 + 右下冷色光晕，让纯色背景更有纵深感 */
.login-page::before,
.login-page::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.login-page::before {
  left: -120px;
  top: -120px;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(255, 138, 71, 0.38) 0%, rgba(255, 138, 71, 0) 68%);
}
.login-page::after {
  right: -140px;
  bottom: -140px;
  width: 460px;
  height: 460px;
  background: radial-gradient(circle, rgba(91, 156, 248, 0.5) 0%, rgba(91, 156, 248, 0) 70%);
}
.login-card {
  position: relative;
  width: 400px;
  max-width: 100%;
  background-color: #fff;
  border-radius: 16px;
  padding: 40px 35px 32px;
  box-shadow: 0 12px 48px rgba(12, 40, 92, 0.26);
}
.login-header {
  text-align: center;
  margin-bottom: 30px;
}
.login-logo {
  width: 62px;
  height: 62px;
  margin-bottom: 12px;
  border-radius: 14px;
}
.login-title {
  font-size: 24px;
  font-weight: 700;
  color: #1F2733;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}
.login-subtitle {
  font-size: 13px;
  color: #78838F;
  margin: 0;
}
.login-form {
  width: 100%;
}
.login-form >>> .el-input__inner {
  height: 44px;
  line-height: 44px;
}
.login-form >>> .el-input__icon {
  line-height: 44px;
}
.code-row {
  display: flex;
  gap: 10px;
}
.code-btn {
  width: 122px;
  height: 44px;
  flex-shrink: 0;
}
.submit-btn {
  width: 100%;
  height: 46px;
  font-size: 16px;
  letter-spacing: 2px;
}
.login-tip {
  text-align: center;
  font-size: 12px;
  color: #A8B0BA;
  margin: 8px 0 0 0;
}

/* ---------- 滑块验证弹层 ---------- */
/* custom-class 挂在 .el-dialog 上，它拿不到本组件的 scope 属性，
   因此必须用会带上 scope 的根节点 .el-dialog__wrapper 来穿透 */
.el-dialog__wrapper >>> .el-dialog__body {
  padding: 20px 24px 18px;
}
.slider-panel {
  width: 100%;
}
.slider-stage {
  position: relative;
  width: 100%;
  line-height: 0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #EEF2F7;
}
.slider-bg {
  display: block;
  width: 100%;
  border-radius: 8px;
}
/* 拼图块绝对定位在背景之上，left 跟随滑块手柄走 */
.slider-puzzle {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25));
}
.slider-track {
  position: relative;
  width: 100%;
  height: 44px;
  margin-top: 14px;
  border-radius: 22px;
  background-color: #EEF2F7;
  border: 1px solid #E4E8EF;
  box-sizing: border-box;
  user-select: none;
}
.slider-track-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 22px 0 0 22px;
  background-color: #D6E6FD;
}
.slider-handle {
  position: absolute;
  left: 0;
  top: -1px;
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background-color: #fff;
  border: 1px solid #2B7EF5;
  box-sizing: border-box;
  color: #2B7EF5;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  box-shadow: 0 2px 8px rgba(43, 126, 245, 0.25);
  transition: box-shadow 0.2s ease;
  z-index: 2;
}
.slider-handle.is-dragging {
  cursor: grabbing;
  box-shadow: 0 4px 14px rgba(43, 126, 245, 0.4);
}
.slider-track-tip {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #A8B0BA;
  pointer-events: none;
}
.slider-hint {
  margin: 12px 0 0 0;
  text-align: center;
  font-size: 12px;
  color: #78838F;
}

@media (max-width: 480px) {
  .login-card {
    padding: 32px 22px 26px;
  }
}
</style>
